jQuery_T4NT(document).ready(function($) {
	   $( document ).on( "variant:changed", function( evt ) {

	   });
// $( document ).on( "variant:changed", function( evt ) {    
//   document.querySelector('#cusvariantid').value = evt.currentVariant.id;
//   if(evt.currentVariant.title.includes('Customized')){
//       document.querySelector('.customForm').style.display = "block";
//   } else {
//       document.querySelector('.customForm').style.display = "none";
//   }
// })
});